<ac-form *ngIf="dialogConfig.ready"
         [formModel]="generalDevice"
         [formSchema]="schema"
         [isEdit]="isEdit"
         [validateAuxiliaryForm]="validateAuxiliaryForm"
         [deleteEmptyStringProperties]="['ipAddress']"
         formModelName="generalDevice">

    <div id="generic-device-dialog-content">
        <div class="flexRowParentEqualChildren">
            <ac-input-container formFieldName="generalDevice.name" label="Name">
                <ac-textfield [(acModel)]="generalDevice.name"
                              textFieldId="general-device-name">
                </ac-textfield>
            </ac-input-container>

            <ac-input-container formFieldName="generalDevice.ipAddress" label="IP">
                <ac-textfield [(acModel)]="generalDevice.ipAddress"
                              textFieldId="general-device-ip">
                </ac-textfield>
            </ac-input-container>
        </div>

        <network-tenant-region-selection [model]="generalDevice"
                                         [additionalSettings]="additionalSettings"
                                         [isEdit]="isEdit"
                                         [ngDisabledTenant]="isEdit"
                                         [ngDisabledRegion]="isEdit"
                                         [regionFormFieldName]="'generalDevice.regionId'"
                                         [horizontalView]="true">
        </network-tenant-region-selection>

        <ac-input-container formFieldName="generalDevice.location" label="Address">
            <ac-geo-location (acChanged)="generalDevice.location=$event"
                             [acModel]="generalDevice.location"></ac-geo-location>
        </ac-input-container>
    </div>
</ac-form>
